/**
 * ganttDragDropUtils - Utility functions, sensor, and types for useGanttDragDrop
 */
import { PointerSensor } from '@dnd-kit/core';
import type { GanttJob } from './useGanttJobs';

// Time conversion helpers

export const minutesToTime = (minutes: number): string => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};

export const timeToMinutes = (time: string): number => {
  const [h, m] = time.split(':').map(Number);
  return h * 60 + m;
};

export const getPosition = (hora: string, startHour: number, totalHours: number): number => {
  const [h, m] = hora.split(':').map(Number);
  const minutesFromStart = (h - startHour) * 60 + m;
  return (minutesFromStart / (totalHours * 60)) * 100;
};

export const getWidth = (duration: number, totalHours: number): number => {
  return (duration / totalHours) * 100;
};

// Custom sensor that ignores elements with data-no-dnd

function shouldHandleEvent(element: HTMLElement | null): boolean {
  let cur = element;
  while (cur) {
    if (cur.dataset && cur.dataset.noDnd === 'true') {
      return false;
    }
    cur = cur.parentElement;
  }
  return true;
}

export class CustomPointerSensor extends PointerSensor {
  static activators = [
    {
      eventName: 'onPointerDown' as const,
      handler: ({ nativeEvent: event }: { nativeEvent: PointerEvent }) => {
        if (
          !event.isPrimary ||
          event.button !== 0 ||
          !shouldHandleEvent(event.target as HTMLElement)
        ) {
          return false;
        }
        return true;
      },
    },
  ];
}

// Types

export interface ResizingJob {
  job: GanttJob;
  handle: 'left' | 'right';
  previewStart?: number;
  previewDuration?: number;
}

// Epic 46: Pending operation for validation
export interface PendingOperation {
  type: 'drag' | 'resize';
  job: GanttJob;
  newHoraInicio: string;
  newHoraFim: string;
  newDuration?: number;
}
